import compact from 'lodash/compact';
import filter from 'lodash/filter';
import compose from 'lodash/fp/compose';
import mapFP from 'lodash/fp/map';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isNil from 'lodash/isNil';
import React, {useMemo} from 'react';

import {useTableGrid} from '@/contexts/tableGridContact';

export default (keysToShow) => {

  // eslint-disable-next-line react/display-name,react/prop-types
  return ({item}) => {
    const {columns} = useTableGrid();

    const columnsToShow = useMemo(() => filter(columns, ({key}) => includes(keysToShow, key)), [columns]);

    const values = useMemo(() => compose(
      compact,
      mapFP(({key, title, dataIndex, render}) => {
        const value = get(item, dataIndex, null);

        if (isNil(value))
          return null;

        const valueToShow = render ? render(value, item) : value;

        return <span key={`m-col-${key}`}>
          <span className="font-medium mr-1">{title}:</span>
          <span>{valueToShow}</span>
        </span>;
      }),
    )(columnsToShow), [columnsToShow, item]);

    return <div className="flex flex-col justify-center lg:hidden text-black">
      {values}
    </div>;
  };
};